(function () {
  // Mobile menu
  var hamburger = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      mobileMenu.classList.toggle('open');
    });
  }

  // Toast
  function toast(msg) {
    var el = document.querySelector('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      document.body.appendChild(el);
    }
    el.innerHTML = msg;
    requestAnimationFrame(function () { el.classList.add('show'); });
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('show'); }, 2500);
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }

  // AJAX add-to-cart for any form with data-ajax-cart
  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var original = btn ? btn.innerHTML : '';
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          updateCartCount();
          if (btn) {
            btn.classList.add('added');
            btn.innerHTML = '&#10003; Added!';
            setTimeout(function () {
              btn.classList.remove('added');
              btn.innerHTML = original;
            }, 2000);
          }
          toast('<span class="accent">&#10003;</span> Added to cart &middot; <a href="' + window.routes.cart_url + '" style="text-decoration:underline">View cart</a>');
        })
        .catch(function () {
          toast('Could not add to cart. Please try again.');
        });
    });
  });

  // Quantity steppers
  document.querySelectorAll('[data-qty-box]').forEach(function (box) {
    var input = box.querySelector('input');
    var dec = box.querySelector('[data-qty-dec]');
    var inc = box.querySelector('[data-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (inc) inc.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // Cart page quantity changes
  document.querySelectorAll('[data-cart-line-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = input.getAttribute('data-line');
      fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(input.value, 10) })
      }).then(function () { window.location.reload(); });
    });
  });

  // PDP gallery
  var mainImg = document.querySelector('[data-gallery-main] img');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      if (mainImg) mainImg.src = btn.getAttribute('data-src');
    });
  });

  updateCartCount();
})();
